<template>
  <LoadingWithText v-if="isLoading" />
  <div v-else>
    <div class="intro-y flex flex-col sm:flex-row items-center mt-8">
      <PageHeader :title="$t('nav.customerDetails')" class="text-lg font-medium mr-auto" />
      <div class="w-full sm:w-auto flex mt-4 sm:mt-0">
        <Button
          type="button"
          :to="{ name: 'Customers' }"
          class="box text-gray-700 dark:text-gray-300 flex mr-2"
        >
          {{ $t('text.back') }}
        </Button>
        <DropDownButtonList
          :id="dropdownId"
          icon-name="DownloadIcon"
          :label="$t('text.downloadFile')"
          class="mr-auto"
          box-class="w-40"
          content-class="dark:bg-dark-1"
        >
          <a @click="onDownload('anket')" role="button">{{ $t('file.resume') }}</a>
          <a @click="onDownload('urgudul')" role="button">{{ $t('file.application') }}</a>
          <a @click="onDownload('contract')" role="button">{{ $t('file.contract') }}</a>
        </DropDownButtonList>
      </div>
    </div>
    <div class="intro-y box px-5 pt-5 mt-5">
      <CustomerDetailsHeader :customer="customer" />
      <div class="nav-tabs flex flex-col sm:flex-row justify-center lg:justify-start">
        <router-link
          :to="{ name: 'CustomerDetails' }"
          class="py-4 sm:mr-8"
          exact-active-class="active"
        >
          {{ $t('text.mainInformation') }}
        </router-link>
        <router-link
          :to="{ name: 'CustomerDetailsLoanHistory' }"
          class="py-4 sm:mr-8"
          exact-active-class="active"
        >
          {{ $t('text.loanHistory') }}
        </router-link>
        <router-link
          :to="{ name: 'CustomerDetailsCreditDatabase' }"
          class="py-4 sm:mr-8"
          exact-active-class="active"
        >
          {{ $t('text.creditDatabase') }}
        </router-link>
        <router-link
          :to="{ name: 'CustomerDetailsSocialInsurance' }"
          class="py-4 sm:mr-8"
          exact-active-class="active"
        >
          {{ $t('text.socialInsurance') }}
        </router-link>
        <router-link
          :to="{ name: 'CustomerDetailsNotesHistory' }"
          class="py-4 sm:mr-8"
          exact-active-class="active"
        >
          {{ $t('text.allNotesHistory') }}
        </router-link>
      </div>
    </div>
    <div class="intro-y tab-content mt-5">
      <router-view v-if="customer" :customer="customer"></router-view>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { CUSTOMER_REQUEST, CUSTOMER_DOCUMENT_DOWNLOAD } from '@/store/actions/customer';
import PageHeader from '@/components/ui/PageHeader';
import Button from '@/components/ui/button/Button';
import DropDownButtonList from '@/components/ui/DropDownButtonList';
import CustomerDetailsHeader from '@/components/customer/CustomerDetailsHeader';

export default {
  data() {
    return {
      dropdownId: 'dropdown-owner',
    };
  },

  computed: {
    ...mapGetters([
      'customer',
      'customerStatus',
      'customerDocumentDownloadStatus',
      'customerDocumentDownloadLink',
    ]),
    isLoading() {
      return this.customerStatus === 'loading' || !this.customer;
    },
    isDownloading() {
      return this.customerDocumentDownloadStatus === 'loading';
    },
  },

  watch: {
    '$route.params.customerId': 'fetchData',
  },

  created() {
    this.fetchData();
  },

  methods: {
    async fetchData() {
      try {
        await this.$store.dispatch(CUSTOMER_REQUEST, this.$route.params.customerId);
      } catch (error) {
        this.$toasted.show(this.$t('toast.failedRoute'), { type: 'error' });
        this.$router.push({ name: 'Customers' });
      }
    },
    async onDownload(value) {
      const payload = {
        id: this.$route.params.customerId,
        data: {
          type: value,
        },
      };
      await this.$store.dispatch(CUSTOMER_DOCUMENT_DOWNLOAD, payload);
      if (this.customerDocumentDownloadStatus === 'success') {
        cash(`#${this.dropdownId}`).dropdown('hide');
        window.open(`${this.customerDocumentDownloadLink}`, '_blank');
      }
    },
  },

  components: {
    PageHeader,
    Button,
    DropDownButtonList,
    CustomerDetailsHeader,
  },
};
</script>
